import React from 'react';
import { createRoot } from 'react-dom/client';
import ErrorBox from '../components/ErrorBox/ErrorBox.jsx';

const node = (() => {
    if (typeof document !== 'undefined') {
        return document.getElementById('errors');
    }

    return undefined;
})();

if (node) {
    const root = createRoot(node);
    root.render(
        <ErrorBox />
    );
}

export default function error(err) {
    if (node) {
        ErrorBox.addError(err);
    }
}
